import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const SubjectMasterProvider = (props) => {
  const api = new API();
  const [fetchSubjectMasterList, setFetchSubjectMasterContextList] =
    useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    page: 1,
    limit: 20,
    category_id: '',
    subcategory_id: '',
  })
  const [loader, setLoader] = useState(false);
  const [editFormSubject] = Form.useForm();
  const [editPopupSubject, setEditPopupSubject] = useState(false);
  const [loaderSubject, setLoaderSubject] = useState(false);
  const [subjectDeleteLoader, setSubjectDeleteLoader] = useState(false);


  const deleteSubject = async (id,fetchSubjectMasterContext) => {
    setSubjectDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("subjectmaster/delete",id, (err, res) => {
        
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchSubjectMasterContext && fetchSubjectMasterContext();
          return;
        } else {
          // Widget.showMessage("error", err?.response?.data?.message);
        }
        setSubjectDeleteLoader(false);
      }));
  }
  const fetchSubjectMasterContext = async (cid, scid) => {
    setLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getAll(
        "subjectmaster",
        {...tableFilter, category_id: cid, subcategory_id: scid },
        (err, res) => {
          setLoader(false);
          if (res?.data?.status === 200) {
            setFetchSubjectMasterContextList(res?.data?.data);
          } else {
            setFetchSubjectMasterContextList([]);
          }
        }
      );
  };

  const addSubject = async (data, cid,scid, onClose,reset) => {
    const form_data = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        form_data.append(key, value);
      }
    });
    form_data.append("category_id", cid);
    form_data.append("subcategory_id", scid);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("subjectmaster/", form_data, (err, res) => {
        if (res?.data?.status === 200) {
          fetchSubjectMasterContext(cid,scid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reset();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }));
  };
  const editSubject = async (data, id, onClose,reset,cid,scid) => {
    const form_data = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        form_data.append(key, value);
      }
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("subjectmaster/edit",id, form_data, (err, res) => {
        if (res?.data?.status === 200) {
          fetchSubjectMasterContext(cid,scid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reset();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }));
  };

  return (
    <Context.Provider
      value={{
        ...props,
        fetchSubjectMasterList,
        fetchSubjectMasterContext,
        addSubject,
        tableFilter,
        setTableFilter,
        loader,
        editSubject,
        editPopupSubject,
        setEditPopupSubject,
        editFormSubject,
        loaderSubject,
        setLoaderSubject,
        subjectDeleteLoader, setSubjectDeleteLoader,
        deleteSubject
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default SubjectMasterProvider;
